import { PriceRangeValues } from '@/components/search/searchFilters';

export function areFacetsEqual(
  a: Record<string, string | PriceRangeValues>,
  b: Record<string, string | PriceRangeValues>,
): boolean {
  const aKeys = Object.keys(a).filter((key) => {
    const val = a[key];
    return typeof val === 'string' ? val.trim().length > 0 : true;
  });

  const bKeys = Object.keys(b).filter((key) => {
    const val = b[key];
    return typeof val === 'string' ? val.trim().length > 0 : true;
  });

  if (aKeys.length !== bKeys.length) return false;

  return aKeys.every((key) => {
    const aVal = a[key];
    const bVal = b[key];

    if (!(key in b)) return false;

    if (typeof aVal === 'string' && typeof bVal === 'string') {
      return aVal.trim() === bVal.trim();
    }

    if (
      typeof aVal === 'object' &&
      aVal !== null &&
      typeof bVal === 'object' &&
      bVal !== null &&
      'min_price' in aVal &&
      'min_price' in bVal
    ) {
      return (
        aVal.min_price === bVal.min_price &&
        aVal.max_price === bVal.max_price
      );
    }

    return false;
  });
}
